import React, { useState, useEffect } from "react";
import useStorageState from "@/hooks/useStorageState";
import { createModel } from "hox";
import { ITechnicianSearch, ITechnicianDetail, ITechnicianStatistics, ITechnicianDetDetail, ITechnicianDetStatistics, ITechnicianDetSearch } from "./technicianTypes"
import { TablePaginationConfig } from "antd/es/table/interface";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, mianCode } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/SCMTypes";
import { technicianService } from "./technicianService";
import { transPgToPagination, formatNum } from "@/utils/utils";
import { convertRes2Blob } from "@/utils/exportFile";
export const useTechnicianModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<ITechnicianDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ITechnicianSearch>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc: ITechnicianStatistics = {
        workHours: 0,
        number: 0,
    }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [descTotal, setDescTotal] = useState<ITechnicianStatistics>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<ITechnicianStatistics>(initDesc);
    const [descRows, setDescRows] = useState<ITechnicianDetail[]>([]);
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { workHour, num } = item
            newRowsDescTotal.workHours += +formatNum(workHour)
            newRowsDescTotal.number += +formatNum(num)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    const loadData = async (page?: ISearchPage, searchValue: ITechnicianSearch = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await technicianService.technicianTotal(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataSource(records);
        setDescTotal(statistics);
    }
    //设置搜索value
    const updateSearchParam = (updateParam: ITechnicianSearch) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }

    //详情列表数据源
    const [dataDetSource, setDataDetSource] = useState<ITechnicianDetDetail[]>([]);
    //查询条件
    const [searchDetParam, setSearchDetParam] = useState<ITechnicianDetSearch>({});
    //分页参数
    const initDetPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDetDesc: ITechnicianDetStatistics = {
        workHours: 0,
        receivableAmount: 0,
        number: 0,
    }
    const [pgDetCfg, setPgDetCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedDetRowKeys, setSelectedDetRowKeys] = useState<string[]>([]);
    const [descDetTotal, setDescDetTotal] = useState<ITechnicianDetStatistics>(initDetDesc);
    //选中的数据统计展示的数据
    const [rowsDescDetTotal, setRowsDescDetTotal] = useState<ITechnicianDetStatistics>(initDetDesc);
    const [descDetRows, setDescDetRows] = useState<ITechnicianDetail[]>([]);
    useEffect(() => {
        let newRowsDescTotal = initDetDesc
        descDetRows.forEach((item) => {
            let { workHour, num, receivableAmount } = item
            newRowsDescTotal.workHours += +formatNum(workHour)
            newRowsDescTotal.receivableAmount += +formatNum(receivableAmount)
            newRowsDescTotal.number += +formatNum(num)
        })
        setRowsDescDetTotal(newRowsDescTotal)
    }, [descDetRows])
    const loadDetData = async (page?: ISearchPage, searchValue: ITechnicianSearch = searchDetParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await technicianService.technicianDetails(searchParams);
        const { records, statistics, ...pg } = retData;
        setPgDetCfg(transPgToPagination({ ...pg, pageNum: pg.current }));
        setDataDetSource(records);
        setDescDetTotal(statistics);
    }
    //设置搜索value
    const updateSearchDetParam = (updateParam: ITechnicianSearch) => {
        setSearchDetParam({ ...searchDetParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchDetParam = (params: ITechnicianSearch) => {
        setSearchDetParam({ ...params });
        setSelectedDetRowKeys([]);
        loadDetData(initPgCfg, { ...params });
    }
    //列表导出
    const technicianTotalExcel = async () => {
        let result = await technicianService.technicianTotalExcel({
            ...searchParam,
            pageSize: 0,
            pageNum: 0,

        });
        convertRes2Blob(result)
    }
    //详情导出
    const technicianDetailsExcel = async () => {
        let result = await technicianService.technicianDetailsExcel({
            ...searchDetParam,
            pageSize: 0,
            pageNum: 0,
        });
        convertRes2Blob(result)
    }
    return {
        dataSource,
        searchParam,
        initPgCfg,
        pgCfg,
        selectedRowKeys,
        setDataSource,
        setSearchParam,
        setPgCfg,
        loadData,
        updateSearchParam,
        resetSearchParam,
        setSelectedRowKeys,
        descTotal, setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        technicianTotalExcel,
        dataDetSource, setDataDetSource,
        searchDetParam, setSearchDetParam,
        initDetPgCfg,
        initDetDesc,
        pgDetCfg, setPgDetCfg,
        selectedDetRowKeys, setSelectedDetRowKeys,
        descDetTotal, setDescDetTotal,
        rowsDescDetTotal, setRowsDescDetTotal,
        descDetRows, setDescDetRows,
        loadDetData,
        updateSearchDetParam,
        resetSearchDetParam,
        technicianDetailsExcel
    }
})